import React from 'react';
import './HomePage.css';
import SiteHeader from './SiteHeader.js';
import HomeIntro from './HomeIntro.js';
import PortfolioGrid from './PortfolioGrid.js';
import ContactFooter from '../Components/ContactFooter.js';

const HomePage = () => {
    return (
        <div className="homepage">
            <SiteHeader />
            <main className="homepage__main">
                <div className="homepage__layout">
                    <HomeIntro />
                    <div className="homepage__work">
                        <PortfolioGrid />
                    </div>
                </div>
            </main>
            <ContactFooter />
        </div>
    );
};

export default HomePage;
